import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { translate } from "app/filters/i18nFilter";
import { renderIndustryDataAvailabilityNotice } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/IndustryDataAvailabilityBanner";
import { useDurationSubtitleFilter } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDurationSubtitleFilter";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";

import { DisplayAdvertisingAdPlacementWidget } from "../../DisplayAdvertisingAdPlacementWidget";
import type { PerformanceResponse } from "../../types";
import { useIndustryAdPlacement } from "./useIndustryAdPlacement";

const EMPTY_PLACEMENT: PerformanceResponse["placements"] = { above: 0, below: 0, farBelow: 0 };

interface IIndustryAdPlacementProps {
    category: IFlattenedCategory;
}

export const IndustryAdPlacement = ({ category }: IIndustryAdPlacementProps) => {
    const { data, isLoading, isError, availability } = useIndustryAdPlacement(category);
    const durationSubtitleFilter = useDurationSubtitleFilter(data?.startDate);

    const showPlacementsEmptyState = !isLoading && (!data || isError);

    return (
        <WidgetContainer
            title={translate("ad.intelligence.overview.ad.placement.widget.title")}
            tooltip={translate("ad.intelligence.overview.ad.placement.widget.title.tooltip")}
            subtitleFilters={[durationSubtitleFilter]}
            height="100%"
            isLoading={isLoading}
            loaderWidth="100%"
            showSubtitleFiltersLoadingState={false}
            loaderHeight={98}
            automationId="industry-ad-placement-widget"
            noticeSlot={renderIndustryDataAvailabilityNotice(availability)}
        >
            <DisplayAdvertisingAdPlacementWidget
                placement={data?.placement ?? EMPTY_PLACEMENT}
                showEmptyState={showPlacementsEmptyState}
                hasError={isError}
            />
        </WidgetContainer>
    );
};
